import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SearchService } from "../../services/search.service";
import * as moment from "moment";
import { ReadJSONService } from "../../services/read-json.service";
import { ModalComponent } from "../layout/modal/modal.component";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { HomeService } from 'src/app/core/http/web/home.service';
import { environment as params, environment } from 'src/environments/environment';

declare var $: any;
declare let ga: Function;
declare global {
  interface Window { dataLayer: any[]; }
}

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
  providers: [SearchService]
})
export class SearchComponent implements OnInit {
  public S3urlBaseMJ: any = (<any>params).api.s3;
  @Input() public isOpen: boolean;
  @Input() public noUseHead: boolean;
  @Input() public noUseBody: boolean;
  @Input() public noUseFooter: boolean;
  @ViewChild('content') cldMdl: ElementRef;
  closeResult: string;
  public widgetData: any = null;

  public dataSearch: any;
  public crossSelling: any = false;
  public selectOns: Boolean = false;
  public updateInsurance: any;
  public addOns: any;
  public addOnSelected: any;
  public products: any = [];
  public selected: any = false;
  public _moment: any;
  public insuranceBudgetAlOn: any;
  public totalSum: any = 0;
  public collapsed: any = false;
  public comparar: any = false;
  public internacional: any = false;
  public numberOfUsers: any = [];
  public onsSelectedByUser: any = [];
  public dataPlans: any;
  public Arr = Array;
  public loader = false;
  public modalType: any = 'none';
  public fDestino;
  public dataLoader: any;
  public dateFromLoader: any;
  public dateToLoader: any;
  public urlBaseMJ: any = (<any>params).api.mj;
  public modalProductSelected: any;

  public slickOptions: any = {
    initialSlide: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 4000,
    arrows: false,
    dots: true,
    pauseOnHover: true,
    centerMode: false,
    responsive: []
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private searchService: SearchService,
    private readJson: ReadJSONService,
    private modalService: NgbModal,
    private _homeService: HomeService,
  ) {
    console.log('send view page', this.router.url);
    if (typeof(ga) !== 'undefined') {
      ga('send', 'pageview', this.router.url);
      ga('send', {
        hitType: 'pageview',
        page: this.router.url
      });
    }

    this.route.queryParams.subscribe(params => {
      if (JSON.stringify(params) !== '{}') {
        this.internacional = params.isInternational;
        this.fDestino = params.fDestino;

        window.dataLayer.push({
          'event': 'category',
          'valData': params.TripType,
          'category': params.TripType
        });

        sessionStorage.setItem('internacional', this.internacional);

        // datos para loader
        this.dataLoader = params;
        moment.locale('es');
        this.dateFromLoader = (moment(this.dataLoader.dateFrom, 'DD/MM/YYYY')).toDate();
        this.dateFromLoader = moment(this.dateFromLoader).format('ddd DD MMM');
        this.dateToLoader = (moment(this.dataLoader.dateTo, 'DD/MM/YYYY')).toDate();
        this.dateToLoader = moment(this.dateToLoader).format('ddd DD MMM');

        this.dataSearch = {
          country: 'mexico',
          dateFrom: params.dateFrom,
          dateTo: params.dateTo,
          passengerIsic: parseInt(params.passengerIsic),
          passengerNormal: parseInt(params.passengerNormal),
          maxAgeIsic: parseInt(params.maxAgeIsic),
          maxAgeNormal: parseInt(params.maxAgeNormal),
          isInternational: params.isInternational,
          isIsic: params.isIsic === 'true' ? true : false,
          sender: 'WEB'
        };

        console.log('build 1 search ---->', this.dataSearch);

        this.products = [];
        this.addOnSelected = [];
        this.addOns = [];
        this.selected = false;
        this.onsSelectedByUser = [];
        this.totalSum = 0;
        this.numberOfUsers = [];

        this.loaderAllData();
        this.selectOns = false;
        this.modalService.dismissAll();

        this.crossSelling = params.cross ? true : false;
      } else {
        this.router.navigate(["/m/seguros/ups-error"]);
      }
    });

    moment.locale('es');
    this._moment = moment;
    this.readJSON(
      (window.location.hostname == "localhost" || window.location.hostname == "webdev.mundojoven.com.s3-website-us-west-2.amazonaws.com" ? "assets/" : this.urlBaseMJ) +
      "json/planes.json",
      "planes"
    );
    this.readJSON(
      (window.location.hostname == "localhost" || window.location.hostname == "webdev.mundojoven.com.s3-website-us-west-2.amazonaws.com"? "assets/" : this.urlBaseMJ) +
      "json/hiddenTable.json",
      "hiddenTable"
    );
    this.readJSON(
      (window.location.hostname == "localhost" || window.location.hostname == "webdev.mundojoven.com.s3-website-us-west-2.amazonaws.com"? "assets/" : this.urlBaseMJ) +
      "json/table.json",
      "table"
    );

    this.dataPlans = JSON.parse(localStorage.getItem('planes'));
  }

  ngOnInit() {
    this.getWidgetOptions();
  }

  selectCardMobile(event) {
    // event
  }

  loaderAllData() {

    sessionStorage.setItem('addOns', JSON.stringify([]));
    if (this.crossSelling) {
      //Do de search
      this.dataSearch.passengerNormal =
        this.dataSearch.passengerNormal + this.dataSearch.passengerIsic;
      this.dataSearch.passengerIsic = 0;
      this.dataSearch.maxAgeIsic = 0;
      this.dataSearch.isIsic = false;

      console.log('send getInformationCrossSelling ---->', this.dataSearch);

      this.searchService.getInformationCrossSelling(this.dataSearch).subscribe(
        response => {
          if (response['data'] && response['data'].length > 0) {
            const data = response['data'];
            this.products = data.filter(addon => addon.productType !== 'AddOn');
          } else {
            console.warn('No hay información', response);
            // this.router.navigate(['ups-error']);
          }
        },
        error => {
          console.error('Error en la busqueda', error);
          this.router.navigate(['/m/seguros/ups-error']);
        }
      );
    } else {
      //Do de search Busca información de los costos de seguros enviando numero de usuarios y datos
      for (let i = 0; i < this.dataSearch.passengerNormal + this.dataSearch.passengerIsic; i++) {
        this.numberOfUsers.push(`Viajero ${i + 1}`);
      }

      console.log('send getInformation  ---->', this.dataSearch);

      this.searchService.getInformation(this.dataSearch).subscribe(
        response => {
          if (response['data'] && response['data'].length > 0) {
            const data = response['data'];
            data.map(seguro => {
              seguro.productType = seguro.productType === 'SUPER' ? 'SUPER' : seguro.productType === 'Super' ? 'SUPER' : seguro.productType;
            });
            const withWindows = $(window).width();
            const superMobile = withWindows < 992 && data.length === 3 ? 2 : false;
            const twMexico = withWindows < 992 && data.length === 2 ? -1 : false;
            data.sort(function (a, b) {
              if (b.productType === 'April' && twMexico !== false) {
                return twMexico;
              }
              if (b.productType === 'BUDGET') {
                return -2;
              }
              if (a.productType === 'UNIV') {
                return -3;
              }
              if (a.productType === 'Mexico') {
                return 0;
              }
              if (a.productType === 'SUPER' && superMobile !== false) {
                return superMobile;
              }
              if (a.productType > b.productType) {
                return -1;
              }
              if (a.productType < b.productType) {
                return 1;
              }
              return 0;
            });

            this.products = data.filter(addon => addon.productType !== 'AddOn');
            //this.products = this.products.filter(addon => addon.productType !== 'UNIV');
            if (this.products.length === 0) {
              this.router.navigate(['/m/seguros/ups-error-content']);
            }

            this.selected = response['data'].filter(({ productType }) => this.capitalize(productType, true) === 'SUPER')[0];

            if (this.selected === undefined) {
              this.selected = response['data'].filter(({ productType }) => {
                return this.capitalize(productType, true) === 'April';
              })[0];
            }
            this.totalSum =
              (this.selected ? this.selected.totalPrice : 0) +
              (this.addOnSelected
                ? this.addOnSelected.reduce(
                  (carry, actual) =>
                    Number(carry) +
                    Number(actual.localPrice / this.selected.vouchers[0].quantity),
                  0
                )
                : 0);

          } else {
            console.warn('No hay información', response);
            // this.router.navigate(['ups-error']);
          }
        },
        error => {
          console.error('Error en la busqueda', error);
          this.router.navigate(['/m/seguros/ups-error']);
        }
      );
    }
  }

  capitalize = (str, allWords = false) => {
    let exp = /^\w/;
    if (allWords) {
      exp = /\b\w/g;
    }
    if (typeof str === 'string') {
      return str.replace(exp, c => c.toUpperCase());
    } else {
      return '';
    }
  }

  // Scroll TOP
  ngAfterViewInit() {
    $(document).ready(function () {
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });

    if (this.crossSelling) {
      sessionStorage.setItem("crossSelling", "true");
    } else {
      sessionStorage.setItem("crossSelling", "false");
    }
  }

  showDetails(ons) {
    let title = "";
    let body = "";
    switch (ons.productName) {
      case 'Deporte Seguro 10K':
        title = '<i class="far fa-futbol"></i>';
        body = `<p class="mb-3">La cobertura ideal para los viajeros que practican deportes a nivel amateur. Estarás protegido ante deportes de nieve, artes marciales, futbol, baloncesto, natación, patinaje y muchos más. No cubre categorías 2 y 3, revisa las condiciones generales.</p>
          <a href='https://mundojoven.com/condiciones-generales/' target='_blank'>MÁS INFORMACIÓN</a>`;
        break;
      case 'Asistencia a la mascota 5K':
        title = '<i class="fas fa-dog"></i>';
        body = `<p class="mb-3">Si tu mascota es parte de tu familia y te acompaña en tu aventura lo protegemos en caso de requerir asistencia por accidente, enfermedad y hospitalización. Revisa condiciones generales.</p>
          <a href='https://mundojoven.com/condiciones-generales/' target='_blank'>MÁS INFORMACIÓN</a>`;
        break;
      case 'Asistencia a la mascota 10K':
        title = '<i class="fas fa-dog"></i>';
        body = `<p class="mb-3">Si tu mascota es parte de tu familia y te acompaña en tu aventura lo protegemos en caso de requerir asistencia por accidente, enfermedad y hospitalización. Revisa condiciones generales.</p>
          <a href='https://mundojoven.com/condiciones-generales/' target='_blank'>MÁS INFORMACIÓN</a>`;
        break;
      case 'Bebé a bordo':
        title = '<i class="fas fa-baby"></i>';
        body = `<p class="mb-3">Protección para urgencias durante el embarazo desde la semana 26 hasta la semana 32 de gestación. Revisa condiciones generales.</p>
          <a href='https://mundojoven.com/condiciones-generales/' target='_blank'>MÁS INFORMACIÓN</a>`;
        break;
      case 'Seguro de Electrónicos':
        title = '<i class="fas fa-laptop"></i>';
        body = `<p class="mb-3">Protege tu celular, computadora, cámara, etc. ante robo o descarga eléctrica. Revisa condiciones generales.</p>
          <a href='https://mundojoven.com/condiciones-generales/' target='_blank'>MÁS INFORMACIÓN</a>`;
        break;
      case 'Seguro de Cancelación':
        title = '<i class="fas fa-user-shield"></i>';
        body = `<p class="mb-3">Protege tu inversión ante cualquier imprevisto. Nuestro seguro de cancelación te ayudará en caso de no poder realizar tu viaje hasta 24 hrs. antes de tu salida. Revisa condiciones generales.</p>
          <a href='https://mundojoven.com/condiciones-generales/' target='_blank'>MÁS INFORMACIÓN</a>`;
        break;
      default:
        title = '<i class="fas fa-shield-alt"></i>';
        body = ``;
        break;
    }

    const modalRef = this.modalService.open(ModalComponent, {
      centered: true,
      windowClass: 'modal-detalles'
    });
    modalRef.componentInstance.typeModal = 'modalDetails';
    modalRef.componentInstance.subTitle = ons.productName;
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.bodyContent = body;
  }

  updateNavBar(prod, mobile = false) {
    if (prod) {
      this.selected = prod;
      this.totalSum =
        (this.selected ? this.selected.totalPrice : 0) +
        (this.addOnSelected
          ? this.addOnSelected.reduce(
            (carry, actual) =>
              Number(carry) +
              Number(actual.localPrice / this.selected.vouchers[0].quantity),
            0
          )
          : 0);
    }
  }

  prevProd(prod, mobile = false) {
    if (mobile && prod.addons) {
      //return this.extraInsurance(prod);
    }
    if (prod) {
      sessionStorage.setItem('product', JSON.stringify(prod));
      this.selected = prod;
      this.nextStep();
      /*
      if (prod.addons) {
        this.selectOns = true;
        sessionStorage.setItem('product', JSON.stringify(prod));
        this.selected = prod;
        this.addOns = prod.addons;
      } else {
        sessionStorage.setItem('product', JSON.stringify(prod));
        this.selected = prod;
        this.nextStep();
      }
      */
    }

    if (sessionStorage.getItem('addOns')) {
      this.addOnSelected = JSON.parse(sessionStorage.getItem('addOns'));
    } else {
      this.addOnSelected = [];
    }

    this.totalSum =
      (this.selected ? this.selected.totalPrice : 0) +
      (this.addOnSelected
        ? this.addOnSelected.reduce(
          (carry, actual) => Number(carry) + Number(actual.localPrice),
          0
        )
        : 0);
  }

  extraInsurance(prod) {
    const modalRef = this.modalService.open(ModalComponent, {
      centered: true,
      windowClass: 'modal-info'
    });
    modalRef.componentInstance.typeModal = 'modalInfo';
    modalRef.componentInstance.title = '¿Deseas añadir extras a tu seguro?';
    modalRef.componentInstance.insuranceSelected = prod;

    modalRef.result.then(
      resp => {
        if (resp.addOns) {
          if (prod.addons) {
            this.selectOns = true;
            sessionStorage.setItem('product', JSON.stringify(prod));
            this.selected = prod;
            this.addOns = prod.addons;
            this.totalSum =
              (this.selected ? this.selected.totalPrice : 0) +
              (this.addOnSelected
                ? this.addOnSelected.reduce(
                  (carry, actual) =>
                    Number(carry) + Number(actual.localPrice),
                  0
                )
                : 0);
          }
        }
      },
      resp => {
        if (prod.addons) {
          sessionStorage.setItem('product', JSON.stringify(prod));
          this.selected = prod;
          this.addOns = prod.addons;
        }
        if (resp.productType === 'BUDGET') {
          const modalRefAceptUpdateSuper = this.modalService.open(
            ModalComponent,
            { centered: true, windowClass: 'modal-update-super' }
          );
          modalRefAceptUpdateSuper.componentInstance.typeModal =
            'modalChangeToSuper';
          modalRefAceptUpdateSuper.componentInstance.title =
            '¡Cámbiate al Plan Súper!';
          modalRefAceptUpdateSuper.componentInstance.subTitle =
            'Mejora tu cobertura y obtén grandes beneficios';
        }
      }
    );
  }

  toPayment(select = null) {
    if (select) {
      sessionStorage.setItem("product", JSON.stringify(select));
    } else {
      sessionStorage.setItem("product", JSON.stringify(this.selected));
    }
    this.buildGeneralDataLayer();
    this.router.navigate(["/m/seguros/step-one"]);
  }

  readJSON(src, name) {
    this.readJson.getJSON(src).subscribe(
      (data: any) => {
        localStorage.setItem(name, JSON.stringify(data));
      },
      err => {
        console.error("Error :", err);
        localStorage.setItem(name, null);
      }
    );
  }

  addProduct(add, target, customer) {
    window.dataLayer.push({
      'event': 'add_ons',
      'valData': add.productName,
      'add_ons': add.productName
    });

    let addOns = [];
    if (target.checked) {
      if (sessionStorage.getItem('addOns')) {
        addOns = JSON.parse(sessionStorage.getItem('addOns'));
        addOns.push({ ...add, customer: customer });
        sessionStorage.setItem('addOns', JSON.stringify(addOns));
      }
      this.addOnSelected = addOns;

      // tslint:disable-next-line: max-line-length
      this.totalSum =
        (this.selected ? this.selected.totalPrice : 0) +
        (this.addOnSelected
          ? this.addOnSelected.reduce(
            (carry, actual) =>
              Number(carry) +
              Number(actual.localPrice / this.selected.vouchers[0].quantity),
            0
          )
          : 0);
    } else {
      const customerForRemove = { ...add, customer: customer };
      const onsList = JSON.parse(sessionStorage.getItem("addOns"));
      const newOnsList = onsList.filter(
        ons => JSON.stringify(ons) !== JSON.stringify(customerForRemove)
      );
      sessionStorage.setItem("addOns", JSON.stringify(newOnsList));
      this.addOnSelected = newOnsList;

      // tslint:disable-next-line: max-line-length
      this.totalSum =
        (this.selected ? this.selected.totalPrice : 0) +
        (this.addOnSelected
          ? this.addOnSelected.reduce(
            (carry, actual) =>
              Number(carry) +
              Number(actual.localPrice / this.selected.vouchers[0].quantity),
            0
          )
          : 0);
    }
  }

  nextStep() {
    if (this.selected.productType === 'BUDGET') {
      const modalRef = this.modalService.open(ModalComponent, {
        centered: true,
        windowClass: 'modalChangeToSuper'
      });
      modalRef.componentInstance.typeModal = 'modalChangeToSuper';
      modalRef.componentInstance.title = '¡Cámbiate al Plan Súper!';
      modalRef.componentInstance.subTitle = 'Mejora tu cobertura y obtén grandes beneficios';

      modalRef.result.then(resp => {
        if (resp.updateTo !== '') {
          const updateBy = this.products.filter(
            p => p.productType === resp.updateTo
          );
          this.selected = updateBy[0];
          sessionStorage.setItem('product', JSON.stringify(this.selected));
          sessionStorage.setItem(
            'addOns-plan',
            JSON.stringify(this.selected.productId)
          );

          // tslint:disable-next-line: max-line-length
          this.totalSum =
            (this.selected ? this.selected.totalPrice : 0) +
            (this.addOnSelected
              ? this.addOnSelected.reduce(
                (carry, actual) =>
                  Number(carry) +
                  Number(
                    actual.localPrice / this.selected.vouchers[0].quantity
                  ),
                0
              )
              : 0);
          this.buildGeneralDataLayer();
          this.router.navigate(['/m/seguros/step-one']);
        }
      });
    } else {
      this.buildGeneralDataLayer();
      this.router.navigate(['/m/seguros/step-one']);
    }
  }


  buildGeneralDataLayer() {
    let part_date;
    let return_date;
    let quantity=0;
    if (this.router.url.includes('/m/seguros/resultados/destino?dateFrom=')) {
      this.route.queryParams.subscribe(params => {
        if (JSON.stringify(params) !== '{}') {
          part_date = params.dateFrom;
          return_date = params.dateTo;
          let pax=JSON.parse(params.fPasajeros)
          quantity=pax.vAdult+pax.vChild
        }
      });
    }

    const data = {
      category: this.fDestino,
      name: this.selected.productType,
      content_type: 'insurance',
      id: this.selected.vouchers[0].productId,
      departing_departure_date: part_date.split("-").reverse().join("-"),
      returning_departure_date: return_date.split("-").reverse().join("-"),
      currency: 'MXN',
      price: this.selected.totalPrice,
      quantity: quantity,
      page_category: 'search',
      url_search: this.router.url,
      visitor_type: 'medium-value',
      add_ons: this.addOns,
      date_search: moment(new Date()).format('YYYY-MM-DD'),
      time_search: moment(new Date()).format('HH:mm')
    };

    window.dataLayer.push({
      'event': 'insurance_selected_product',
      'valData': data,
      'insurance_selected_product': data
    });
  }

  seeDetails($event) {
    $event.preventDefault();
    const modalRef = this.modalService.open(ModalComponent, {
      centered: true,
      windowClass: ''
    });
    modalRef.componentInstance.typeModal = 'detailsOfPurchase';
    modalRef.componentInstance.title = 'Detalle de compra';
    modalRef.componentInstance.numberOfUsers = this.numberOfUsers;
    modalRef.componentInstance.insuranceSelected = this.selected;
    modalRef.componentInstance.onsAdded = JSON.parse(
      sessionStorage.getItem('addOns')
    );
  }

  loadMobileDetailsInsurance() { }

  /**
   * mobile
   */
  selectProduct(id, product) {
    if (sessionStorage.getItem('product')) {
      localStorage.removeItem('product');
      sessionStorage.setItem('product', JSON.stringify(product));
    } else {
      sessionStorage.setItem('product', JSON.stringify(product));
    }

    if (sessionStorage.getItem('addOns-plan')) {
      if (Number(sessionStorage.getItem('addOns-plan')) != id) {
        sessionStorage.setItem('addOns', JSON.stringify([]));
        sessionStorage.setItem('addOns-plan', id);
      }
    } else {
      sessionStorage.setItem('addOns-plan', id);
    }
  }

  showInfoDetails(event) {
    if ($(event.target).hasClass("icon")) {
      if ($(event.target).hasClass("fa-info")) {
        $(event.target)
          .removeClass("fas fa-info")
          .addClass("fas fa-times");
      } else {
        $(event.target)
          .removeClass("fas fa-times")
          .addClass("fas fa-info");
      }
    }

    $(event.target.parentElement)
      .parent()
      .siblings('.content-detail-insurance')
      .toggleClass('is_active');
  }

  openModal(type) {
    this.modalType = type;
    this.open1();
  }

  open1() {
    this.modalService.open(this.cldMdl, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  selectProductModalInfo(product){
    this.modalProductSelected=product;
  }

  getWidgetOptions() {
    this._homeService.getWidgetOptions('widget_motor_seguros').subscribe(
      data => {
        this.widgetData = data;
        if (
          !(
            data &&
            data.widget_motor_seguros &&
            JSON.stringify(data.widget_motor_seguros).length > 3
          )
        ) {
          console.warn('Sin data widgets');
        }
      },
      err => {
        console.error(err);
      }
    );
  }

}
